import React, { useEffect, useState } from "react";
import swal from "sweetalert";

export interface PinInputProps {
  seconds?: number;
  otp?: string | any[];
  otpSent?: boolean;
  _verifyOtp: (otp: string) => void;
  miniLoading?: boolean;
  fromHome?: boolean;
  error?: { isTrue: boolean; Error?: string };
  _subscribe: (msisdn: string) => void;
  phNumber: string;
  utm_source?: string;
}

export default function PinInput(props: PinInputProps) {
  let inputRef1: HTMLInputElement | null = null;
  let inputRef2: HTMLInputElement | null = null;
  let inputRef3: HTMLInputElement | null = null;
  let inputRef4: HTMLInputElement | null = null;
  const [otp, setOtp] = useState("");
  const [otp1, setOtp1] = useState("");
  const [otp2, setOtp2] = useState("");
  const [otp3, setOtp3] = useState("");
  const [otpStatus, setOtpStatus] = useState(false);

  useEffect(() => {
    if (props.seconds && props.otp) {
      setOtp(props.otp[0]);
      setOtp1(props.otp[1]);
      setOtp2(props.otp[2]);
      setOtp3(props.otp[3]);
    } else if (props.otp && props.otpSent) {
      setOtp(props.otp[0]);
      setOtp1(props.otp[1]);
      setOtp2(props.otp[2]);
      setOtp3(props.otp[3]);
    } else {
      if (!props.otpSent) {
        setOtp("");
        setOtp1("");
        setOtp2("");
        setOtp3("");
      }
    }
  }, [props]);

  useEffect(() => {
    if (props.seconds && props.otp) {
      setTimeout(() => {
        verify();
      }, props.seconds);
    }
  }, [otp, otp1, otp2, otp3]);

  const verify = () => {
    if (!otp || !otp1 || !otp2 || !otp3) {
      swal("Please Enter Complete OTP");
    } else {
      let _OTP = otp + otp1 + otp2 + otp3;
      props._verifyOtp(_OTP);
    }
  };

  useEffect(() => {
    if (!props.otpSent) {
      setOtp("");
      setOtp1("");
      setOtp2("");
      setOtp3("");
    }
  }, []);

  useEffect(() => {
    if (props.otpSent) {
      setOtpStatus(true);
    }
  });

  return (
    <>
      {otpStatus ? (
        <div className="w-100 mt-4 mw-600">
          <p className="fw-bold">Enter OTP</p>
          <div className="d-flex align-items-center">
            <form
              className="w-100 pin"
              onSubmit={(e) => {
                e.preventDefault();
              }}
            >
              <div className=" d-flex align-items-center justify-content-between w-100">
                <div className="d-flex justify-content-between w-100 align-items-center">
                  <div className="py-3 px-2 mw-80px br-10px me-3 pin-border">
                    <input
                      ref={(ref) => {
                        inputRef1 = ref;
                      }}
                      type="text"
                      autoFocus
                      value={otp}
                      onChange={(val) => {
                        let value = val.target.value;
                        if (value.trim().length > 0) {
                          var numbers = /^[-+]?[0-9]+$/;
                          if (value.match(numbers)) {
                            inputRef2?.focus();
                            setOtp(value);
                          }
                        }
                      }}
                      onKeyDown={(e) => {
                        if (otp.length !== 0) {
                          setOtp("");
                        } else if (otp.length === 0) {
                          if (e.keyCode === 8) {
                            inputRef1?.focus();
                          }
                        }
                      }}
                      autoComplete="off"
                      required
                      className="form-control p-0 text-center"
                      maxLength={1}
                    />
                  </div>
                  <div className="py-3 px-2 mw-80px br-10px  me-3 pin-border">
                    <input
                      ref={(ref) => {
                        inputRef2 = ref;
                      }}
                      type="text"
                      value={otp1}
                      onChange={(val) => {
                        let value = val.target.value;
                        if (value.trim().length > 0) {
                          var numbers = /^[-+]?[0-9]+$/;
                          if (value.match(numbers)) {
                            inputRef3?.focus();
                            setOtp1(value);
                          }
                        }
                      }}
                      onKeyDown={(e) => {
                        if (otp1.length !== 0) {
                          setOtp1("");
                        } else if (otp1.length === 0) {
                          if (e.keyCode === 8) {
                            inputRef1?.focus();
                          }
                        }
                      }}
                      className="form-control p-0 text-center"
                    />
                  </div>
                  <div className="py-3 px-2 mw-80px br-10px me-3 pin-border">
                    <input
                      ref={(ref) => {
                        inputRef3 = ref;
                      }}
                      type="text"
                      value={otp2}
                      onChange={(val) => {
                        let value = val.target.value;
                        if (value.trim().length > 0) {
                          var numbers = /^[-+]?[0-9]+$/;
                          if (value.match(numbers)) {
                            inputRef4?.focus();
                            setOtp2(value);
                          }
                        }
                      }}
                      onKeyDown={(e) => {
                        if (otp2.length !== 0) {
                          setOtp2("");
                        } else if (otp2.length === 0) {
                          if (e.keyCode === 8) {
                            inputRef2?.focus();
                          }
                        }
                      }}
                      className="form-control p-0 text-center"
                    />
                  </div>
                  <div className="py-3 px-2 mw-80px br-10px me-3 pin-border">
                    <input
                      type="text"
                      ref={(ref) => {
                        inputRef4 = ref;
                      }}
                      value={otp3}
                      onChange={(val) => {
                        let value = val.target.value;
                        if (value.trim().length > 0) {
                          var numbers = /^[-+]?[0-9]+$/;
                          if (value.match(numbers)) {
                            setOtp3(value);
                            inputRef4?.blur();
                          }
                        } else if (otp3 !== "") {
                          setOtp3("");
                        }
                      }}
                      onKeyDown={(e) => {
                        if (otp3.length !== 0) {
                          setOtp3("");
                        } else if (otp3.length === 0) {
                          if (e.keyCode === 8) {
                            inputRef3?.focus();
                          }
                        }
                      }}
                      maxLength={1}
                      className="form-control p-0 text-center"
                    />
                  </div>
                </div>
                {props.miniLoading === true ? (
                  <button
                    className="btn btn-sm btn-red w-125 text-white br-10px py-2  px-0 fw-bold"
                  >
                    <div
                      className="spinner-border text-white spinner-border-sm m-2"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </button>
                ) : (
                  <div className="d-none d-md-block">
                    <button
                      disabled={!otp || !otp1 || !otp2 || !otp3 ? true : false}
                      onClick={verify}
                      className="btn btn-sm btn-red w-125 text-white br-10px py-2  px-0 fw-bold _hover"
                    >
                      Subscribe{" "}
                    </button>
                  </div>
                )}
              </div>
            </form>
          </div>

          <div className="w-100  text-start mt-3">
            <div>
              {props.fromHome && (
                <>
                  {props.error?.isTrue ? (
                    <small className="text-red">{props.error.Error}</small>
                  ) : (
                    ""
                  )}
                </>
              )}

              <small className="fw-bold">
                <br />
                Didn’t Received OTP?{"  "}
                <span
                  className="text-red cursor-pointer"
                  onClick={() => {
                    setOtp("");
                    setOtp1("");
                    setOtp2("");
                    setOtp3("");
                    props._subscribe(props.phNumber);
                  }}
                >
                  Resend
                </span>
              </small>
            </div>
            <div>
              {" "}
              <small className="fw-light x-small">
              </small>
            </div>
          </div>
          <div className="w-100 d-block mt-3 text-center d-md-none">
            <button
              disabled={!otp || !otp1 || !otp2 || !otp3 ? true : false}
              onClick={verify}
              className="btn btn-sm btn-red w-100 text-white br-10px py-2 px-5 fw-bold _hover"
            >
              Subscribe{" "}
            </button>
          </div>
        </div>
      ) : null}
    </>
  );
}

PinInput.defaultProps = {
  otpSent: false,
};
